// Single source of truth for the public production origin. Used for
// canonical URLs, og:url, JSON-LD @id, sitemap, etc.
//
// We hardcode this because canonical links MUST always point at the
// production hostname — even when rendered from the preview domain — so
// search engines deduplicate correctly.
export const SITE_URL = "https://builtdifferenthockey.com";
export const SITE_NAME = "Built Different Hockey";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

export const absoluteUrl = (path = "/") => {
  if (!path) return SITE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};
